import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity11 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_11;
}

export default DirtRoadTileEntity11;
